import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from 'theme/withStyles';
import RawHtml from 'common/RawHtml';
import GroupsNav from 'groups/GroupsNav';
import renderGroups from 'utils/renderGroups';
import ErrorMsg from 'common/ErrorMsg';

import rootStyles from './styles/root';

const styles = (theme) => {
  const common = {
    root: rootStyles(theme),
  };
  return {
    ...common,
    root: {
      ...common.root,
      '& .btn-grp-back': {
        display: 'none',
      },
      '& .btn-row-group': {
        display: 'flex',
      },
      '& .grp-label': {
        [`@media(max-width: ${theme.screenSizes.mobileMax}px)`]: {
          display: 'none',
        },
      },
      '& .nav-tabs': {
        display: 'flex',
        margin: [0, 'auto', theme.spacing.md, 'auto'],
        maxWidth: 600,
      },
      '& .region-groups form': {
        '& fieldset': {
          '&.active': {
            display: 'block',
          },
          display: 'none',
          margin: [0, 0, 40, 0],
          maxWidth: theme.forms.maxWidth,
          padding: [0, theme.spacing.md],
        },
        display: 'flex',

        justifyContent: 'center',
      },
      maxWidth: '100%',
    },
  };
};

export const UserauthInternationalBare = ({ classes, groups, headerHtml }) => (
  <div className={classnames('userauth-view', classes.root)}>
    <RawHtml>{headerHtml}</RawHtml>

    <ErrorMsg type="page" />

    <div className="row">
      <div className="widget">
        <div className="region-groups-nav">
          <GroupsNav />
        </div>
        <div className="region-groups">{renderGroups(groups)}</div>
      </div>
    </div>
  </div>
);

UserauthInternationalBare.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  groups: PropTypes.shape({}).isRequired,
  headerHtml: PropTypes.string,
};

UserauthInternationalBare.defaultProps = {
  headerHtml: null,
};

const mapStateToProps = (state) => ({
  groups: state.groups,
  headerHtml: state.page.headerHtml,
});

const UserauthInternationalStyled = withStyles(styles)(UserauthInternationalBare);

export default connect(mapStateToProps)(UserauthInternationalStyled);
